<template>
  <div class="base-bg" v-if="visible">
    <TopBar :title="$t('moduleTitles.safeSetting')" @onClickClose="close" @onClickSave="handleSubmit"></TopBar>
    <div class="set-content">
      <a-row>
        <a-col>
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :model="form">
            <a-form-model-item has-feedback :label="$t('login.password')">
              <a-input v-model="form.pwd" :placeholder="$t('message.pwdErr')" />
            </a-form-model-item>
            <a-form-model-item has-feedback >
              <a-input v-model="conformPwd" :placeholder="$t('form.accountSecure.field.confirmPassword.label')" />
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TopBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      conformPwd: "",
      form: {
        pwd: "",
      },
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {
    this.form.pwd = this.vrbase.sets.view_passwd;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      // if(!this.form.pwd || !this.conformPwd ) {
      //   this.$message.error("請完整填寫密碼");
      //   return;
      // }
      if(this.form.pwd !== this.conformPwd) {
        this.$message.error(this.$t('form.accountSecure.field.confirmPassword.inconformityMessage'));
        return;
      }
      const vrbase = {
          ...this.vrbase,
          sets: { ...this.vrbase.sets, view_passwd: this.form.pwd },
        }
      this.$store
        .dispatch("saveVRBase", {
        vrbase,
        showLoading: true,
      })
        .then(() => {
          this.$emit("close");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {
  /deep/ .ant-input,
  /deep/ .ant-select-selection,
  /deep/ .ant-input-number-input {
    background-color: #333 !important;
    border: 1px solid #555;
    color: #fff;
  }

  /deep/ .ant-form-item-label > label {
    color: #fff !important;
  }

  /deep/ span + * {
    color: #fff;
  }
}
</style>